<script setup lang="ts">
  import ApprovalRadioButton from './ApprovalRadioButton.vue';

  withDefaults(
    defineProps<{
      modelValue: string;
      approveOptionLabel?: string;
      rejectOptionLabel?: string;
    }>(),
    {
      approveOptionLabel: 'Aprovar documento',
      rejectOptionLabel: 'Reprovar documento',
    }
  );

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
  }>();

  const updateValue = (value: string) => {
    emit('update:modelValue', value);
  };
</script>

<template>
  <div class="flex flex-row p-6 gap-8">
    <ApprovalRadioButton
      :label="approveOptionLabel"
      action="approve"
      :model-value="modelValue"
      @update:model-value="updateValue"
    />
    <ApprovalRadioButton
      :label="rejectOptionLabel"
      action="reject"
      :model-value="modelValue"
      @update:model-value="updateValue"
    />
  </div>
</template>
